<template>
    <v-app>
        <v-snackbar
                v-model="snackbar"
                top=true
                color="red"
                timeout=4000
        >
            {{ errorMsg }}
            <v-btn
                    color="white"
                    icon
                    @click="snackbar = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>
        <v-container class="mt-10">
          <v-tour name="myTour" :steps="steps"></v-tour>
            <div v-if="loading">
                <v-row>
                    <v-col>
                        Chargement des rendez-vous en cours.<br>
                        Veuillez patienter
                    </v-col>
                </v-row>
            </div>
            <div v-if="!loading && rdvs.length == 0">
                <v-row>
                    <v-col>
                        <v-alert color="indigo" dark>
                            <h3>Pas de nouveau rendez-vous à prendre en charge.</h3>
                        </v-alert>
                    </v-col>
                </v-row>
            </div>
          <v-sheet
              elevation="10"
              class="pa-4 mt-2"
              color="red lighten-4"
          >
            <p class="text-left">
              <strong>Nouveau 12/10/2020 : </strong> Vous disposez d'un menu en haut à gauche qui vous permet d'accéder aux nouvelles fonctionnalités :
            </p>
            <ul class="text-left">
              <li><strong>Votre portefeuille : </strong>gérer l'ensemble des prospects avec lesquels vous avez été en contact avec Hyundai Connect.</li>
              <li><strong>Votre agenda : </strong>planifier vos journées de travail en planifiant différentes tâches relatives à la vie de vos contacts.</li>
              <li><strong>Tarifier : </strong>consulter l'ensemble du tarifier directement depuis l'application Hyundai Connect. Effectuez également vos simulations de financement d'un simple clic.</li>
              <li><strong>Vos statistiques : </strong>visualiser d'un coup d'oeil vos ventes, prospects perdus ainsi que le volume de vos rendez-vous Hyundai Connect.</li>
            </ul>
          </v-sheet>
            <div v-if="!loading && rdvs.length > 0">
              <v-sheet
                elevation="6"
                class="pa-4"
                color="indigo"
              >
                <h2 class="white--text">De prospects attendent qu'on les contacte !</h2>
                <p class="mt-4 white--text text-center">Cliquez sur le bouton "J'ACCEPTE LA MISSION" et le prospect vous sera attribué.</p>
              </v-sheet>


                <div v-for="rdv in rdvs" v-bind:key="rdv.id">
                  <v-sheet
                    elevation="6"
                    class="pl-6 pr-6 mt-2"
                  >
                    <v-row v-if="rdv.assignedagentid == '' || rdv.assignedagentid == userId" style="background-color: rgba(255, 255, 255, .6);" class="mb-2">
                        <v-col>
                            <h4 class="text-left">Le {{rdv.computed.date}} à {{rdv.computed.heure}}</h4>
                            <p class="text-left">
                                Contacter {{rdv.name}} par {{rdv.contactmethod}}
                                <br>
                                GSM :
                                <span v-if="rdv.contactmethod == 'WhatsApp'"><a :href="'whatsapp://send?phone=' + rdv.computed.whatsappnumber">{{rdv.gsm}}</a></span>
                                <span v-if="rdv.contactmethod == 'Téléphone'"><a :href="'tel:'+rdv.computed.whatsappnumber">{{rdv.gsm}}</a></span>
                                <span v-if="rdv.contactmethod == 'Skype'">{{rdv.gsm}}</span>
                                <br>
                                Mail : {{rdv.mail}}
                                <span v-if="rdv.contactmethod == 'Skype'">
                                    <br>
                                        Skype : <a :href="'skype:'+rdv.skypeid+'?call'">{{rdv.skypeid}}</a>
                                </span>
                                <br>
                            </p>

                        </v-col>
                        <v-col class="text-left">
                            <v-btn v-if="rdv.assignedagentid == ''" color="primary" class="float-right btnAcceptMission" @click="acceptRdv(rdv)">J'accepte la mission</v-btn>
                            <v-btn v-if="rdv.assignedagentid == userId && rdv.customdata.statusappel == ''" color="primary" class="float-right" :to="{ name: 'ViewConnect', params: { id: rdv.id }}">Faire l'appel</v-btn>
                            <p v-if="rdv.assignedagentid == userId && rdv.customdata.statusappel != ''">
                                <strong>Status de l'appel :</strong> {{ rdv.customdata.statusappel }}<br>
                                <span v-if="rdv.customdata.budgetclient != ''"><strong>Budget du client :</strong>{{ rdv.customdata.budgetclient }}<br></span>
                                <span v-if="rdv.customdata.typeachatclient != ''"><strong>Type d'achat :</strong> {{ rdv.customdata.typeachatclient }}<br></span>
                                <span v-if="rdv.customdata.interetclient != ''"><strong>Niveau Intérêt du Client :</strong> {{ rdv.customdata.interetclient }}<br></span>
                                <span v-if="rdv.customdata.prochaineactionclient != ''"><strong>Prochaine action planifiée :</strong> {{ rdv.customdata.prochaineactionclient }}<br></span>
                                <span v-if="rdv.customdata.commentaireclient != ''"><strong>Commentaire :</strong> {{ rdv.customdata.commentaireclient }}<br></span>
                                <span v-if="rdv.customdata.statusappel == 'Effectué'"><strong>Intéressé par :</strong> <span v-for="model in rdv.customdata.modelsclient" v-bind:key="model.name"><span v-if="model.selection == true">{{model.name}}, </span></span></span>
                            </p>

                        </v-col>
                    </v-row>
                  </v-sheet>
                </div>
            </div>
        </v-container>
    </v-app>
</template>

<script>
    import NProgress from "nprogress"

    export default {
        name: "ListeNouvelleDemande",
        data () {
            return {
                snackbar: false,
                errorMsg: '',
                loading: false,
                rdvs: []
            }
        },
        methods: {
            getNewRdv(){
                NProgress.start()
                this.loading = true
                let params = {}
                console.log("On demande les nouveaux rdv")
                params.action = 'getNewRdv'
                this.axios
                    .post(this.$store.state.rootUrl+'apiSalesNew.php',params,{timeout: 10000})
                    .then((data) => {
                        console.log(data)
                        if(data.error === true){
                            console.log("Erreur")
                            this.errorMsg = 'Oups. Nous ne parvenons pas a récupérer les derniers rendez-vous !'
                            this.snackbar = true
                            this.loading = false;
                            NProgress.done()
                            return false
                        }
                        let results = []

                        data.data.data.forEach((element) => {
                            element.calendarurl = this.$store.state.rootUrl+'apiSalesNew.php?action=getCalendarLink&token='+this.$store.state.user.jwt+'&rdvid='+element.id
                            results.push(element)
                        })
                        this.rdvs = results
                        NProgress.done()
                    })
                    .catch( error => {
                        console.log(error);
                        this.errorMsg = 'Oups. Impossible de joindre le serveur ! Veuillez réessayer dans quelques instants'
                        this.snackbar = true
                        NProgress.done()
                    })
                this.loading = false
                NProgress.done()
            },
            acceptRdv(rdv){
                if(!confirm('Etes vous sur de vouloir prendre en charge le prospect '+rdv.name+'?')){
                    return false;
                }
                NProgress.start()
                this.loading = true
                var params = {}

                params.action = 'acceptRdv'
                params.id = rdv.id
                this.axios
                    .post(this.$store.state.rootUrl+'apiSalesNew.php',params,{timeout: 10000})
                    .then((data) => {
                        if(data.error === true){
                            this.errorMsg = 'Impossible de changer le status du RDV. Veuillez réessayer dans quelques instants'
                            this.snackbar = true
                            NProgress.done()
                            return false
                        }
                        window.open(this.$store.state.rootUrl+'apiSalesNew.php?action=getCalendarLink&token='+this.$store.state.user.jwt+'&rdvid='+params.id, '_blank');
                        location.reload()
                        NProgress.done()
                    })
                    .catch( () => {
                        this.errorMsg = 'Oups Erreur Serveur. Veuillez réessayer dans quelques instants'
                        this.snackbar = true
                        NProgress.done()
                    })
                this.loading = false
                NProgress.done()
            }
        },
        mounted () {
            this.getNewRdv()
        }
    }
</script>

<style scoped>

</style>
